module.exports = __webpack_public_path__ + "img/book_shouci.d3a4265a.png";